import script from "./animatedGifttwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./animatedGifttwo.vue?vue&type=script&setup=true&lang=ts"

import "./animatedGifttwo.vue?vue&type=style&index=0&id=40789a5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40789a5e"]])

export default __exports__